(ns net.kestec.mhda-pilgrimage.test.form-test
  (:require
    ["@mui/material/Typography" :default Typography]
    ["@mui/material/MobileStepper" :default MobileStepper]
    ["@mui/material/Button" :default Button]
    ["@mui/material/Stepper" :default Stepper]
    ["@mui/material/Step" :default Step]
    ["@mui/material/StepLabel" :default StepLabel]
    ["@mui/material/Paper" :default Paper]
    ["@mui/material/Grid" :default Grid]
    ["@mui/material/Checkbox" :default Checkbox]
    ["@mui/material/FormGroup" :default FormGroup]
    ["@mui/material/FormControlLabel" :default FormControlLabel]

    ["@mui/icons-material/KeyboardArrowLeft" :default KeyboardArrowLeft]
    ["@mui/icons-material/KeyboardArrowRight" :default KeyboardArrowRight]

    [net.kestec.mhda-pilgrimage.public.page-structure :refer [base-page]]
    [net.kestec.mhda-pilgrimage.lib-ui.form-components :refer [grid-small grid-full text-field text-field-multi checkbox switch radio radio-group checkbox-group]]
    [net.kestec.mhda-pilgrimage.db :as-alias db]
    [day8.re-frame.http-fx]
    [reagent.core :as r]
    ))

(defn main []
  [base-page
   [:> Paper {:sx {:padding "7px"}}
    [:br]
    [:> Typography {:variant "h2"} "ANMELDUNG"]
    [:br]
    [:> Typography {:variant "h3"} "für die MALTESER Rom-Wallfahrt 2026"]


    [:br]
    [:> Stepper {:activeStep 1 :alternativeLabel true}
     [:> Step {:key 1} [:> StepLabel {:sx {:color "green"}} [:> Typography {:variant "span" :sx {:display {:xs "none" :md "block"}}} "Informationen"]]]
     [:> Step {:key 2} [:> StepLabel [:> Typography {:variant "span" :sx {:display {:xs "none" :md "block"}}} "Persönliche Daten"]]]
     [:> Step {:key 3} [:> StepLabel [:> Typography {:variant "span" :sx {:display {:xs "none" :md "block"}}} "Reisedetails"]]]
     [:> Step {:key 4} [:> StepLabel [:> Typography {:variant "span" :sx {:display {:xs "none" :md "block"}}} "Kurzfragebogen"]]]
     [:> Step {:key 5} [:> StepLabel [:> Typography {:variant "span" :sx {:display {:xs "none" :md "block"}}} "Bildrechte"]]]
     [:> Step {:key 6} [:> StepLabel [:> Typography {:variant "span" :sx {:display {:xs "none" :md "block"}}} "Finanzieller Beitrag"]]]
     ]
    [:br]
    [:> Typography {:variant "p" :sx {:color "darkred"}} "Bitte unbedingt alle Blätter dieses Formulars vollständig und leserlich ausfüllen und Ihre \nAdresse und Telefonnummer für allfällige Rückfragen angeben! "]



    [:br]
    [:br]



    [:> Grid {:container true}

     [grid-full [:> Typography {:variant "h5"} "Für das Namensschild"]]
     [grid-small
      [text-field {:label "Vorname"}]]
     [grid-small
      [text-field {:label "Familienname"}]]

     [grid-full [:> Typography {:variant "h5"} "Name laut Reisedokument (Pass oder Personalausweis)"]]
     [grid-small
      [text-field {:label "Vorname"}]]
     [grid-small
      [text-field {:label "Familienname"}]]
     [grid-small
      [text-field {:label "Ausweisnummer"}]]
     [grid-small
      [text-field {:label "Austellungsdatum"}]]
     [grid-small
      [text-field {:label "Gültig bis"}]]

     [grid-full [:> Typography {:variant "h5"} "Daten"]]
     [grid-small
      [text-field {:label "Geburtsdatum"}]]
     [grid-small
      [text-field {:label "Geburtsort"}]]
     [grid-full
      [text-field {:label "Straße/Hausnummer/Top"}]]
     [grid-small
      [text-field {:label "Postleitzahl"}]]
     [grid-small
      [text-field {:label "Ort"}]]
     [grid-small
      [text-field {:label "Telefonnummer"}]]
     [grid-small
      [text-field {:label "Email"}]]

     [grid-full [:> Typography {:variant "h5"} "Reiseversicherung"]]
     [grid-small [:> Typography {:variant "span"} "Ich habe eine Reiseversicherung (ÖAMTC Mitglied, VISA, AMEX)"]]
     [grid-small
      [radio-group {"Ja"   "yes"
                    "Nein" "no"}]
      ]







     [grid-full [:> Typography {:variant "h5"} "TEST TEST"]]

     [:> Grid {:xs 12 :sx {:padding "7px"}}
      [text-field-multi {:label "Textfield Multi"}]]


     [grid-small
      [checkbox {:label "Checkbox 1" :value "1"}]
      ]
     [grid-small
      [checkbox {:label "Checkbox 2" :value "2"}]
      ]
     [grid-full
      [checkbox-group {"CheckboxGroup 1" "1" "CheckboxGroup 2" "2" "CheckboxGroup 3" "3"}]
      ]
     [grid-full
      [radio-group {"Radio 1" "value1"
                    "Radio 2" "value2"
                    "Radio 3" "value3"}]
      ]
     [:> Grid {:xs 12 :sx {:padding "7px"}}
      [switch {:label "Switch 1" :value "value1"}]
      [switch {:label "Switch 2" :value "value2"}]
      ]


     [:> MobileStepper {:variant    "dots"
                        :steps      6
                        :position   "static"                ; without its always on top
                        :sx         {:width "100%" :maxWidth "1680px" :flexGrow 1 :margin "0 auto 0 auto"}
                        :activeStep 1
                        :nextButton (r/as-element [:> Button
                                                   {:variant "outlined"  :color "secondary"}
                                                   "Weiter" [:> KeyboardArrowRight]])
                        :backButton (r/as-element [:> Button
                                                   {:disabled true :variant "outlined"}
                                                   [:> KeyboardArrowLeft] "Zurück"])

                        }
      ]

     ]]])